module.exports = __webpack_public_path__ + "static/media/logo.6e149135.svg";